<template>
    <div>
        <CuentaAtras @tiempoTerminado="volver"/>
        <PageTitle :title="$t('nuevo_abono.titulo', { temporada: lista.nombre, abono: teatro.texto_abono })" class="strech"/>

        <PasoUnoComponent
            id="paso1"
            :desactivar="!paso1_activo"
            :datos_compradores="datos_compradores"
            @rellenarDatos="rellenarDatos"
        />
    </div>
</template>

<script>
    import PasoUnoComponent from '../lfp/steps/PasoUnoComponent';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';

    export default {
        data() {
            return {
                paso1: true,
                paso1_activo: true,
                paso2: false,
                datos_compradores:  [{}],
                session_id: null
            }
        },
        methods: {
            rellenarDatos(datos_compradores, session_id) {
                this.datos_compradores = datos_compradores;
                this.session_id = session_id;
                this.paso2 = true;
                this.paso1_activo = false;
            },
            volver() {
                this.datos_compradores = [{}];
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            PasoUnoComponent, PageTitle, CuentaAtras
        }
    }
</script>